import { isPlatformBrowser } from '@angular/common';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AccountSandbox } from '../account/account.sandbox';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        public snackBar: MatSnackBar,
        @Inject(PLATFORM_ID) private platformId: any,
        private accountSandbox: AccountSandbox
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
        let token = null;
        if (isPlatformBrowser(this.platformId)) {
            const localToken = localStorage.getItem('userToken');
            const sessionToken = sessionStorage.getItem('userToken');
            token = localToken ? localToken : sessionToken ? sessionToken : null;
        }

        // req = req.clone({
        //     setHeaders: {
        //         accept: 'application/json'
        //     }
        // });

        if (token) {
            req = req.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token
                }
            });
        }
        return next.handle(req).pipe(
            map((user: any) => {
                return user;
            }),
            catchError(response => {
                if (response.status === 200 || response.status === 201) {
                    return response;
                }
                switch (response.status) {
                    case 400:
                        this.handleBadRequest(response);
                        break;
                    case 401:
                        this.handleUnAuthorized();
                        break;
                    case 403:
                        this.handleUnAuthorized();
                        break;
                    case 500:
                        this.handleServerError();
                        break;
                    default:
                        break;
                }
                return throwError(response);
            })
        );
    }

    private handleBadRequest(responseBody: any): void {
        if (responseBody.error) {
            try {
                const bodyParsed = responseBody.error;
                this.handleErrorMessages(bodyParsed);
            } catch (error) { }
        }
    }

    private handleErrorMessages(response: any): void {
        if (!response) {
            return;
        } else {
            this.showNotificationError(response.message);
        }
    }

    private handleUnAuthorized(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.clear();
            sessionStorage.clear();
            document.cookie = 'token_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            this.accountSandbox.doLogout();
            this.showNotificationError('Unauthorized!');
            this.router.navigate(['/']);
        }
    }

    handleServerError(): void {
        this.showNotificationError('ServerError');
    }

    private showNotificationError(message: string): void {
        this.snackBar.open(message, 'Close', {
            panelClass: ['notification', 'notification--error'],
            verticalPosition: 'bottom',
            horizontalPosition: 'right',
            duration: 7000
        });
    }

}

